import {CustomHeader} from "../../../../../components/AGGrid/cell-renderers/custom-header";

export const id = {
    field: 'id',
    headerName: 'ID',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'contacts',
    }
};

export const contact = {
    field: 'name',
    headerName: 'Contact',
    flex: 4,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'name',
        page: 'contacts',
    }
};

export const rightslineId = {
    field: 'rightsLineId',
    headerName: 'Rightsline ID',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'rightsLineId',
        page: 'contacts',
    }
};

export const formerlyKnownAs = {
    field: 'formerlyKnownAs',
    headerName: 'Formerly Known As',
    flex: 3,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'formerlyKnownAs',
        page: 'contacts',
    }
};

export const lobs = {
    field: 'lobs',
    headerName: 'LOBs',
    flex: 5,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'lobs',
        page: 'contacts',
    }
};

export const canadianOrigination = {
    field: 'canadianOrig',
    headerName: 'Canadian Origination',
    flex: 3,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'canadianOrig',
        page: 'contacts',
    }
};

export const type = {
    field: 'typeCode',
    headerName: 'Type',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'typeCode',
        page: 'contacts',
    }
};

export const alternateName = {
    field: 'alternateName',
    headerName: 'Alternate Name',
    flex: 3,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'alternateName',
        page: 'contacts',
    }
};

export const alternateContact = {
    field: 'apolloContact',
    headerName: 'Alternate Contact',
    flex: 3,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'apolloContact',
        page: 'contacts',
    }
};

export const apolloId = {
    field: 'apolloId',
    headerName: 'Apollo ID',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'apolloId',
        page: 'contacts',
    }
};
